import { Shield, Target, Users } from "lucide-react";
import type { Position } from "./types";

export const positions: Position[] = [
  {
    id: 1,
    name: "突击位",
    description: "队伍的先锋，负责开团和突破",
    icon: Target,
    color: "bg-red-500",
    characteristics: ["高机动性", "强攻击力", "承担风险"],
    recommendedLegends: ["艾许", "恶灵", "机器人"],
  },
  {
    id: 2,
    name: "信息位",
    description: "队伍的大脑，负责战术制定和信息收集",
    icon: Users,
    color: "bg-blue-500",
    characteristics: ["全局视野", "战术思维", "团队协调"],
    recommendedLegends: ["密客", "琉雀"],
  },
  {
    id: 3,
    name: "支援位",
    description: "队伍的后盾，负责治疗和资源管理",
    icon: Shield,
    color: "bg-green-500",
    characteristics: ["团队意识", "稳定发挥", "资源管理"],
    recommendedLegends: ["命脉", "罗芭", "纽卡索"],
  },
];
